export enum UserRoleEnum {
    ADMIN_SPACE = 'ADMIN_SPACE',
}
